import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChCreateLaboratoryPrescriptionMutation as useChCreateLaboratoryPrescriptionMutationType } from "@/modules/patients/detail/laboratory-prescription/ch/services/__generated__/useChCreateLaboratoryPrescriptionMutation.graphql"

const mutation = graphql`
  mutation useChCreateLaboratoryPrescriptionMutation($input: Ch_createLaboratoryPrescriptionInput!) {
    ch_createLaboratoryPrescription(input: $input) {
      ch_LaboratoryPrescription {
        id
        ...chLaboratoryPrescriptionDrawerFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChCreateLaboratoryPrescriptionMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChCreateLaboratoryPrescriptionMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChCreateLaboratoryPrescriptionMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChCreateLaboratoryPrescriptionMutation }
